import LanguageSelector from './LanguageSelector';

globalThis.LanguageSelectorComponents = {
  LanguageSelector,
};
